import React from "react";
import { Box } from "@mui/material";
import ValidValuesFooter from "./footers/valid-values-footer";
import ReclassifyValuesFooter from "./footers/reclassify-values-footer";
import PurgeValuesFooter from "./footers/purge-values-footer";
import PurgeEntitiesFooter from "./footers/purge-entities-footer";
import ChangeValuesFooter from "./footers/change-values-footer";
import MoveValuesFooter from "./footers/move-values-footer";
import SplitValuesFooter from "./footers/split-values-footer";
import { DistinctValue } from "../../types";
import { EntityFieldItem } from "../../services/cleaning-data-service";

interface CategoryFooterFactoryProps {
  selectedCategory: number;
  fieldId: number | undefined;
  checked: { [key: string]: boolean };
  mainValues: DistinctValue[];
  selectedItem: DistinctValue | null;
  refreshDistinctValues: () => void;
  availableFields: EntityFieldItem[] | undefined;
  isLoadingFields: boolean;
}

/**
 * Factory component that returns the appropriate footer based on selectedCategory.
 * Each footer handles its own onComplete and onCancel logic internally.
 */
export const CategoryFooterFactory: React.FC<CategoryFooterFactoryProps> = ({
  selectedCategory,
  fieldId,
  checked,
  mainValues,
  selectedItem,
  refreshDistinctValues,
  availableFields,
  isLoadingFields,
}) => {
  switch (selectedCategory) {
    case 1: // Valid Values
      return (
        <ValidValuesFooter
          fieldId={fieldId}
          checked={checked}
          mainValues={mainValues}
          refreshDistinctValues={refreshDistinctValues}
        />
      );
    case 2: // Reclassify Values
      return (
        <ReclassifyValuesFooter
          fieldId={fieldId}
          checked={checked}
          mainValues={mainValues}
          selectedItem={selectedItem}
          refreshDistinctValues={refreshDistinctValues}
        />
      );
    case 3: // Purge Values
      return (
        <PurgeValuesFooter
          fieldId={fieldId}
          checked={checked}
          mainValues={mainValues}
          selectedItem={selectedItem}
          refreshDistinctValues={refreshDistinctValues}
        />
      );
    case 4: // Change Values
      return (
        <ChangeValuesFooter
          selectedItem={selectedItem}
          fieldId={fieldId}
          refreshDistinctValues={refreshDistinctValues}
        />
      );
    case 6: // Move Values
      return (
        <MoveValuesFooter
          fieldId={fieldId}
          checked={checked}
          mainValues={mainValues}
          selectedItem={selectedItem}
          refreshDistinctValues={refreshDistinctValues}
          availableFields={availableFields}
          isLoadingFields={isLoadingFields}
        />
      );
    case 7: // Split Values
      return (
        <SplitValuesFooter
          fieldId={fieldId}
          selectedItem={selectedItem}
          refreshDistinctValues={refreshDistinctValues}
          availableFields={availableFields}
          isLoadingFields={isLoadingFields}
        />
      );
    case 8: // Purge Entities
      return (
        <PurgeEntitiesFooter
          fieldId={fieldId}
          checked={checked}
          mainValues={mainValues}
          selectedItem={selectedItem}
          refreshDistinctValues={refreshDistinctValues}
        />
      );
    default:
      return (
        <Box
          sx={{
            borderTop: "1px solid #eee",
            height: "64px",
          }}
        />
      );
  }
};

export default CategoryFooterFactory;
